import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Container = styled.div`
  cursor: pointer;
  padding: 5px 15px;
  background-color: ${theme.colors.green1};
  border-radius: ${theme.border.smallRadius};
  color: ${theme.colors.boldGreen};
  font-weight: ${theme.font.semiBold};
  font-size: 14px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
`

export const Switch = styled.span`
  position: absolute;
  border-radius: ${theme.border.smallRadius};
  color: ${theme.colors.white};
  top: 0;
  transition: all 0.3s ease-in-out;
  padding: 5px 15px;
  z-index: 1;

  &.unavailable {
    background-color: ${theme.colors.erro};
    font-weight: ${theme.font.normal};
    left: 50%;
    transform: translateX(-4px);
  }

  &.available {
    left: 0;
    background-color: ${theme.colors.green4};
    font-weight: ${theme.font.semiBold};
  }
`
